export function Button({
  as: Comp = 'button',
  variant = 'primary',
  className = '',
  ...props
}) {
  const base =
    'inline-flex items-center justify-center rounded-xl px-4 py-2.5 text-sm font-semibold transition focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 focus:ring-offset-slate-50 disabled:cursor-not-allowed disabled:opacity-60';

  const styles =
    variant === 'primary'
      ? 'bg-sky-700 text-white hover:bg-sky-800'
      : variant === 'secondary'
        ? 'bg-white text-slate-900 ring-1 ring-inset ring-slate-200 hover:bg-slate-50'
        : 'text-slate-900';

  return <Comp className={[base, styles, className].join(' ')} {...props} />;
}

